import { TrendingUp } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React from 'react';

import EnhacedBox from '../../../../../../../lib/designSystem/Box';
import CombinedChart from '../../../../../../../lib/designSystem/Charts/CombinedChart';
import { formatMoney } from '../../../../../../../lib/functions/utils';

interface TrendsChartProps {
  data: any;
}

const TrendsChart: React.FC<TrendsChartProps> = ({ data }) => {
  if (!data?.nomineesByPeriod || data.nomineesByPeriod.length === 0) {
    return (
      <EnhacedBox small>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(15, 35, 223, 0.12)',
            }}
          >
            <TrendingUp sx={{ fontSize: 18, color: '#0F23DF' }} />
          </div>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '1.1rem',
            }}
          >
            Evolución de Montos por Período
          </Typography>
        </div>
        <div
          style={{
            height: 280,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body1" color="text.secondary">
            No hay datos disponibles para mostrar la evolución de montos
          </Typography>
        </div>
      </EnhacedBox>
    );
  }

  const chartData = data.nomineesByPeriod.reduce((acc: any, item: any) => {
    acc[item.period] = {
      quantity: item.resells,
      amount: item.amount,
    };
    return acc;
  }, {});

  return (
    <CombinedChart
      data={chartData}
      title="Evolución de Montos por Período"
      icon={<TrendingUp sx={{ fontSize: 18, color: '#0F23DF' }} />}
      primaryColor="#0F23DF"
      secondaryColor="#10B981"
      height={250}
      yAxisLabel="Cantidad de Reventas"
      rightYAxisLabel="Monto (CLP)"
      customMargin={{ left: 80, right: 80, top: 30, bottom: 80 }}
      customQuantityValueFormatter={(value) => value?.toString() || '0'}
      customAmountValueFormatter={(value) => formatMoney(value || 0)}
      customYAxisValueFormatter={(value) => value.toString()}
      customRightYAxisValueFormatter={(value) =>
        `${(value / 1000000).toFixed(1)}M`
      }
    />
  );
};

export default TrendsChart;
